var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.506 0h5.037c1.942 0 1.942 4 0 4H1.456c-1.941 0-1.941-4 0-4h8.05Z",
    fill: "#365063"
  })));
};

export { SvgMinus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iNCIgdmlld0JveD0iMCAwIDE2IDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05LjUwNjA5IDBIMTQuNTQzNEMxNi40ODU1IDAgMTYuNDg1NSA0IDE0LjU0MzQgNEg5LjUwNjA5SDEuNDU2NDRDLTAuNDg1NDc5IDQgLTAuNDg1NDc5IDAgMS40NTY0NCAwSDkuNTA2MDlaIiBmaWxsPSIjMzY1MDYzIi8+Cjwvc3ZnPgo=";